// TODO: Get rid of test listeners on either end test or new test

import * as constants from '../../constants';
import Test from '../../test';
import textButton from '../../shared-ui/text-button';
import newQuestionResultIcon from '../../shared-ui/question-result-icon';

const submitBtnHeight = 50;
const yOffset = submitBtnHeight / 2;

let currentTest;

export const sprite = new PIXI.Sprite();
sprite.anchor.set(0.5, 0);

const qInProgressContainer = new PIXI.Container();
const qCompletedContainer = new PIXI.Container();
sprite.addChild(qInProgressContainer);
sprite.addChild(qCompletedContainer);

// QUESTION IN PROGRESS
const submitBtn = textButton({ text: 'SUBMIT', bgColour: constants.green, height: submitBtnHeight });
const skipBtn = textButton({ text: 'SKIP', bgColour: constants.red });
qInProgressContainer.addChild(submitBtn);
qInProgressContainer.addChild(skipBtn);
submitBtn.anchor.set(0.5, 0);
skipBtn.anchor.set(0.5, 0);
submitBtn.y = yOffset;
skipBtn.y = yOffset + submitBtnHeight + 10;

skipBtn.on('pointerdown', () => {
  currentTest.currentQuestion.answer = null;
  completeCurrentQuestion();
});
submitBtn.on('pointerdown', completeCurrentQuestion);

// QUESTION COMPLETED
const tick = newQuestionResultIcon(true);
const cross = newQuestionResultIcon(false);
const nextQuestionBtn = textButton({ text: 'NEXT QUESTION', bgColour: constants.lightBlue });
const quizSummaryBtn = textButton({ text: 'QUIZ SUMMARY', bgColour: constants.green });
qCompletedContainer.addChild(tick);
qCompletedContainer.addChild(cross);
qCompletedContainer.addChild(quizSummaryBtn);
qCompletedContainer.addChild(nextQuestionBtn);
quizSummaryBtn.anchor.set(0.5, 0);
nextQuestionBtn.anchor.set(0.5, 0);
tick.y = cross.y = yOffset + 5;
nextQuestionBtn.y = quizSummaryBtn.y = yOffset + submitBtnHeight + 10;

nextQuestionBtn.on('pointerdown', () => currentTest.gotoNextQuestion());
quizSummaryBtn.on('pointerdown', () => currentTest.end());

Test.eventEmitter.on('TEST_START', test => {
  currentTest = test;
});

Test.eventEmitter.on('TEST_NEXT_QUESTION', test => {
  submitBtn.enabled = currentTest.currentQuestion.answer !== null;
  qInProgressContainer.visible = true;
  qCompletedContainer.visible = false;
});

Test.eventEmitter.on('TEST_ANSWER_CHANGED', test => {
  submitBtn.enabled = currentTest.currentQuestion.answer !== null;
});

function completeCurrentQuestion() {
  currentTest.currentQuestion.isCompleted = true;

  qInProgressContainer.visible = false;
  qCompletedContainer.visible = true;

  tick.visible = currentTest.currentQuestion.result;
  cross.visible = !tick.visible;

  nextQuestionBtn.visible = !currentTest.isOnLastQuestion;
  quizSummaryBtn.visible = !nextQuestionBtn.visible;
}
